import { Injectable } from 'angular-ts-decorators';

import { Observable, Subject, merge } from 'rxjs';
import { mapTo } from 'rxjs/operators';

import { WindowStreams } from '@core/app/scripts/services/window-streams';

/**
 * Service that notifies component with js-based styling that screen changed
 * size & they should redo their size calculation
 */
@Injectable('redraw')
export class Redraw {
  private forceRedraw$: Subject<void>;

  constructor(private windowStreams: WindowStreams) {
    'ngInject';

    this.forceRedraw$ = new Subject<void>();

    this.update$ = merge(
      this.windowStreams.resize$.pipe(mapTo(undefined)),
      this.forceRedraw$,
    );
  }

  /**
   * Stream that emits on each size change
   */
  update$: Observable<void>;

  /**
   * Force update on components. To be called whenever component changes it's
   * size in a way it can affect other elements - especially ones with js-based
   * styling.
   * @return {void} nothing
   */
  forceRedraw(): void {
    this.forceRedraw$.next();
  }
}
